<div class="assist-panel" role="dialog" aria-label="Izzy writing assistant" (mousedown)="$event.stopPropagation()">
  <div class="assist-header">
    <span class="assist-title"><i class="fa-solid fa-wand-magic-sparkles"></i> Izzy writing assistant</span>
    @if (scopeLabel) {
      <span class="assist-scope">{{ scopeLabel }}</span>
    }
    <button type="button" class="assist-close" (click)="discard.emit()" title="Close (Esc)"><i class="fa-solid fa-xmark"></i></button>
  </div>

  @switch (state) {
    @case ('menu') {
      <div class="assist-menu">
        @for (item of items; track item.operation) {
          <button type="button" class="assist-item" [disabled]="itemDisabled(item)" (click)="pick.emit(item)"
                  [title]="itemDisabled(item) ? 'Write or select some text first' : item.label">
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
            @if (item.needsInstruction) {
              <i class="fa-solid fa-chevron-right assist-item-more"></i>
            }
          </button>
        }
      </div>
    }
    @case ('instruction') {
      <div class="assist-instruction">
        <div class="assist-subtitle">
          <button type="button" class="assist-link" (click)="back.emit()"><i class="fa-solid fa-chevron-left"></i></button>
          <i [class]="selectedItem?.icon || ''"></i> {{ selectedItem?.label }}
        </div>
        <textarea #instructionBox class="assist-input" rows="2" maxlength="500" [placeholder]="selectedItem?.instructionPrompt || ''"
                  [value]="instruction" (input)="onInstructionInput(instructionBox.value)" (keydown)="onInstructionKeydown($event)"></textarea>
        <div class="assist-actions">
          <span class="assist-hint">{{ instruction.length }}/500 · Enter to run</span>
          <button type="button" class="assist-btn primary" [disabled]="!instruction.trim()" (click)="run.emit()">
            <i class="fa-solid fa-wand-magic-sparkles"></i> Go
          </button>
        </div>
      </div>
    }
    @case ('running') {
      <div class="assist-running">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>{{ selectedItem?.label }}… the result goes straight into your message.</span>
        @if (slow) {
          <span class="assist-hint">Still working. You can cancel and keep writing.</span>
        }
        <button type="button" class="assist-btn" (click)="discard.emit()">Cancel</button>
      </div>
    }
    @case ('error') {
      <div class="assist-error">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ error }}</span>
        <div class="assist-actions">
          <button type="button" class="assist-btn" (click)="discard.emit()">Close</button>
          @if (selectedItem) {
            <button type="button" class="assist-btn primary" (click)="retry.emit()"><i class="fa-solid fa-rotate-right"></i> Try again</button>
          }
        </div>
      </div>
    }
  }
</div>
